<script>
import moment from 'moment'
import InfiniteLoading from 'vue-infinite-loading'

export default {
  name: 'TicketFormTable2',
  components: {
    InfiniteLoading,
  },
  props: {
    customer: {
      type: String,
      required: true,
    },
    usedTickets: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    items: [],
    loading: false,
    ts: String(new Date().getTime()),
    next: null,
  }),
  computed: {
    headers() {
      return [
        {
          text: this.$t('reservation.ticketFormTable2.text.purchaseDate'),
          value: 'created',
        },
        {
          text: this.$t('reservation.ticketFormTable2.text.ticketGroup'),
          value: 'groupName',
        },
        {
          text: this.$t('reservation.ticketFormTable2.text.name'),
          value: 'name',
        },
        {
          text: this.$t('reservation.ticketFormTable2.text.expiryDate'),
          value: 'expiryAt',
        },
        {
          text: this.$t('reservation.ticketFormTable2.text.restQuantity'),
          value: 'restQuantity',
        },
        {
          text: this.$t('reservation.ticketFormTable2.text.status'),
          value: 'status',
        },
      ]
    },
  },
  methods: {
    reload() {
      this.items = []
      this.next = null
      this.ts = String(new Date().getTime())
    },
    async fetchData($state) {
      try {
        this.loading = true
        let { results, next } = await (this.next
          ? this.$api.http.get(this.next)
          : this.$api
              .purchasedTickets()
              .list({ customer: this.customer, usable: false }))
        this.items = this.items.concat(results)
        // this.$emit('items', this.items)
        this.next = next
        if (this.items.length) $state.loaded()
        if (!this.next) $state.complete()
      } catch (err) {
        console.error(err)
        $state.error()
      }
      this.loading = false
    },
    status(item) {
      if (item.restQuantity <= 0) return this.$t('reservation.ticketFormTable2.text.used')
      if (moment(item.expiryAt).isBefore(new Date())) return this.$t('reservation.ticketFormTable2.text.expired')
    },
  },
}
</script>

<template>
  <v-data-table
    :headers="headers"
    :items="items"
    :loading="loading"
    :items-per-page="items.length"
    height="400px"
    hide-default-footer
    fixed-header
  >
    <template #item.created="{ value }">
      {{ value | date("'YY MM/DD") }}
    </template>
    <template #item.expiryAt="{ value }">
      {{ value | date("'YY MM/DD") }}
    </template>
    <template #item.status="{item}">
      <v-chip v-if="usedTickets.includes(item.id)" outlined>
        {{ $t('reservation.ticketFormTable2.text.inUse') }}
      </v-chip>

      <template v-if="!item.isActive">
        {{ $t('reservation.ticketFormTable2.text.deactivated', { date: $options.filters.datetime(item.updated) }) }}
      </template>
      {{ status(item) }}
    </template>
    <template #body.append>
      <tr>
        <td :colspan="headers.length">
          <infinite-loading :identifier="ts" @infinite="fetchData" />
        </td>
      </tr>
    </template>
  </v-data-table>
</template>
